import type { UIMessage } from 'ai';

import type {
  CompanionProfile,
  StarterSpec,
  SubjectEntityType,
  SubjectText,
  ThreadMeta,
} from '../types';
import { request } from './companionRequest';

const json = (method: string, body: unknown): RequestInit => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export const getUserProfile = () => request<CompanionProfile>('/api/auth/me');

export const getThreads = () => request<ThreadMeta[]>('/api/threads');

export const getThreadMessages = (threadId: ThreadMeta['id']) =>
  request<UIMessage[]>(`/api/threads/${threadId}`);

export const renameThread = (threadId: ThreadMeta['id'], name: string) =>
  request(`/api/threads/${threadId}`, json('PATCH', { name }));

export const deleteThread = (threadId: ThreadMeta['id']) =>
  request(`/api/threads/${threadId}`, { method: 'DELETE' });

export const getStarters = () => request<StarterSpec[]>('/api/starters');

export const getSubjectText = (entityType: SubjectEntityType) =>
  request<SubjectText>(`/api/subject/${entityType}`);
